import { remove } from 'lodash';
import { createSelector } from 'reselect';

export const pathFrom = (...chunks) => {
  const crumbs = remove(chunks, undefined).map(crumb =>
    encodeURIComponent(crumb),
  );

  return `/${crumbs.join('/')}`.replace('//', '/');
};

const isChildRoute = ({ href }, link) =>
  href.match(link.href) && href.replace(link.href, '').length;

const setGroupChildrenRoutes = (link, _, group) => ({
  ...link,
  children: group.filter(l => isChildRoute(l, link)),
});

export const setChildrenRoutes = createSelector(
  links => links,
  links =>
    links.map(group => ({
      ...group,
      children: group.children.map(setGroupChildrenRoutes),
    })),
);
